import { Injectable } from '@angular/core';
import { ConsolidatedDueDateFilter } from '@interfaces/consolidated-due-date/consolidated-due-date.filter';
import { ConsolidatedDueDateResponse } from '@interfaces/consolidated-due-date/consolidated-due-date.response';
import { VaultApiService } from '@services/api/vault-api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConsolidatedDueDateHttpService {
  private readonly endpoint = 'consolidated-due-date';

  constructor(private readonly apiService: VaultApiService) {}

  /**
   * Obtém dados consolidados de vencimentos em um período específico.
   * @param filters Filtros de data (obrigatórios) e empresa (opcional).
   * @returns Um Observable com os dados consolidados ou null em caso de erro.
   */
  getConsolidatedData(
    filters: ConsolidatedDueDateFilter
  ): Observable<ConsolidatedDueDateResponse | null> {
    return this.apiService.get<ConsolidatedDueDateResponse>(this.endpoint, {}, filters);
  }
}
